import type { ButtonHTMLAttributes } from 'react';

// An on/off pill for filter bars: several can be on at once, or one of a group (presets).
export function ToggleChip({
  pressed,
  className = '',
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & { pressed: boolean }) {
  return (
    <button
      {...props}
      type="button"
      aria-pressed={pressed}
      className={`rounded-full border px-3 py-1 text-sm font-medium transition-colors ${
        pressed
          ? 'border-blue-600 bg-blue-600 text-white hover:bg-blue-700'
          : 'border-slate-300 bg-white text-slate-700 hover:border-blue-400 hover:text-blue-700'
      } ${className}`}
    />
  );
}
